module.exports = __webpack_public_path__ + "static/media/licenta33.54af8916.png";